
//animate.css
exports.animateCss = require('./animate.css/animate-index.js');



// WEBPACK FOOTER //
// ./lib/ctr-nodes/preset/animation/preset-animation-index.js